import { Button } from "rsuite";
import { SvgExport } from "../../assets/icons/index";
import { LibExport } from "../generic/exportDownload";
import { AppRoutesApi } from '../../config/appRoutes';
import { UserFilterType } from "./UsersListTable.component";

const getExportFileName = (filterType: UserFilterType): string => {
  switch (filterType) {
    case "paid":
      return "Subscribed Paid Users";
    case "regbrief":
      return "Regbrief Subscribed Users";
    case "trial":
      return "Trial Users";
    default:
      return "All Users";
  }
};

export const ExportUserListButton = ({ filterType }: { filterType: UserFilterType }) => {
  const isAllUsers = filterType === "all";
  const buttonTitle = isAllUsers ? "Export All Users" : "Export Filtered Users";
  const fileName = getExportFileName(filterType);
  
  const handleExport = () => {
    if (isAllUsers) {
      LibExport.DownloadExport(AppRoutesApi.User.ExportUserList, fileName);
    } else {
      LibExport.DownloadExport(AppRoutesApi.User.ExportFilteredUserList(filterType), fileName);
    }
  };
  
  return (
    <Button
      size="sm"
      appearance="primary"
      className="table-extra-buttons fw-bold "
      onClick={handleExport}
    >
      <SvgExport /> {buttonTitle}
    </Button>
  );
};
